"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function () {}; return { s: F, n: function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function (e) { throw e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function () { it = it.call(o); }, n: function () { var step = it.next(); normalCompletion = step.done; return step; }, e: function (e) { didErr = true; err = e; }, f: function () { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        let key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: () => from[key],
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
// If the importer is in node compatibility mode or this is not an ESM
// file that has been converted to a CommonJS file using a Babel-
// compatible transform (i.e. "__esModule" has not been set), then set
// "default" to the CommonJS "module.exports" for node compatibility.
isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
  value: mod,
  enumerable: true
}) : target, mod));
var __toCommonJS = mod => __copyProps(__defProp({}, "__esModule", {
  value: true
}), mod);
var client_exports = {};
__export(client_exports, {
  BatchTranscription: () => BatchTranscription
});
module.exports = __toCommonJS(client_exports);
var import_connection = require("../config/connection");
var import_request = require("../utils/request");
var import_poll = __toESM(require("../utils/poll"));
class BatchTranscription {
  constructor(config) {
    this._apiKey = void 0;
    this.config = new import_connection.ConnectionConfigFull(config);
  }
  get apiKey() {
    var _this$_apiKey;
    return (_this$_apiKey = this._apiKey) !== null && _this$_apiKey !== void 0 ? _this$_apiKey : typeof this.config.apiKey === "string" ? this.config.apiKey : void 0;
  }
  async refreshApiKey() {
    if (typeof this.config.apiKey === "string") return this.config.apiKey;
    const newKey = await this.config.apiKey();
    this._apiKey = newKey;
    return newKey;
  }
  async refreshOnFail(doRequest) {
    try {
      var _this$apiKey;
      return await doRequest((_this$apiKey = this.apiKey) !== null && _this$apiKey !== void 0 ? _this$apiKey : await this.refreshApiKey());
    } catch (e) {
      console.info("Retrying due to error:", e);
      return await doRequest(await this.refreshApiKey());
    }
  }
  async get(endpoint, contentType, queryParams) {
    return await this.refreshOnFail(key => (0, import_request.request)(key, this.config.batchUrl, endpoint, "GET", null, _objectSpread(_objectSpread({}, queryParams), {}, {
      [import_request.SM_APP_PARAM_NAME]: this.config.appId
    }), contentType));
  }
  async post(endpoint) {
    let body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    let contentType = arguments.length > 2 ? arguments[2] : undefined;
    return await this.refreshOnFail(key => (0, import_request.request)(key, this.config.batchUrl, endpoint, "POST", body, {
      [import_request.SM_APP_PARAM_NAME]: this.config.appId
    }, contentType));
  }
  async delete(endpoint, params) {
    return this.refreshOnFail(key => (0, import_request.request)(key, this.config.batchUrl, endpoint, "DELETE", null, _objectSpread(_objectSpread({}, params), {}, {
      [import_request.SM_APP_PARAM_NAME]: this.config.appId
    })));
  }
  /**
   * The main method for transcribing audio files. It takes a url or a buffer and returns a promise with a transcript.
   *
   *
   * @param config TranscribeConfig
   * @returns Promise<RetrieveTranscriptResponse>. A promise that resolves to a transcript.
   */
  async transcribe(_ref) {
    let input = _ref.input,
      fileName = _ref.fileName,
      transcription_config = _ref.transcription_config,
      translation_config = _ref.translation_config,
      output_config = _ref.output_config,
      summarization_config = _ref.summarization_config,
      auto_chapters_config = _ref.auto_chapters_config,
      topic_detection_config = _ref.topic_detection_config,
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? "json-v2" : _ref$format;
    if (this.config.apiKey === void 0) throw new Error("Error: apiKey is undefined");
    const fileOrFetchConfig = "fetch" in input ? input.fetch : input;
    const submitResponse = await this.createJob({
      input: fileOrFetchConfig,
      fileName,
      transcription_config,
      translation_config,
      output_config,
      summarization_config,
      auto_chapters_config,
      topic_detection_config
    });
    if (submitResponse === null || submitResponse === void 0) {
      throw "Error: submitResponse is undefined";
    }
    await (0, import_poll.default)(async () => {
      const _await$this$getJob = await this.getJob(submitResponse.id),
        job = _await$this$getJob.job;
      if (job.status === "rejected") {
        throw job.errors;
      } else if (job.status === "done") {
        return true;
      } else {
        return false;
      }
    }, 3e3,
    // repeat every 3 seconds
    15 * 60 * 1e3
    // 15 minutes timeout
    );

    return await this.getJobResult(submitResponse.id, format);
  }
  async createJob(_ref2) {
    let input = _ref2.input,
      fileName = _ref2.fileName,
      transcription_config = _ref2.transcription_config,
      translation_config = _ref2.translation_config,
      output_config = _ref2.output_config,
      summarization_config = _ref2.summarization_config,
      auto_chapters_config = _ref2.auto_chapters_config,
      topic_detection_config = _ref2.topic_detection_config;
    if (this.config.apiKey === void 0) throw new Error("Error: apiKey is undefined");
    const config = {
      type: "transcription",
      transcription_config,
      translation_config,
      output_config,
      summarization_config,
      auto_chapters_config,
      topic_detection_config
    };
    const formData = new FormData();
    if ("url" in input) {
      config.fetch_data = input;
    } else {
      formData.append("data_file", input, fileName);
    }
    formData.append("config", JSON.stringify(config));
    return this.post("/v2/jobs", formData);
  }
  async listJobs() {
    let filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return this.get("/v2/jobs", "application/json", filters);
  }
  async getJob(id) {
    return this.get(`/v2/jobs/${id}`, "application/json");
  }
  async deleteJob(id) {
    let force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const params = force ? {
      force
    } : void 0;
    return this.delete(`/v2/jobs/${id}`, params);
  }
  async getJobResult(jobId, format) {
    const params = {
      format: format === "text" ? "txt" : format
    };
    const contentType = format === "json-v2" ? "application/json" : "text/plain";
    return this.get(`/v2/jobs/${jobId}/transcript`, contentType, params);
  }
  async getDataFile(jobId) {
    return this.get(`/v2/jobs/${jobId}/data`, "application/json");
  }
  async getFeatureDiscovery() {
    return this.get("/v1/discovery/features");
  }
}